<template>
    <div id="OtherRecord">
        <el-card class="table_searchbar">
            <el-row style="margin-bottom:20px">
                <el-col :span="5">
                    <div class="y_table" @keydown.enter="btnSearch()">
                        <span class="title y_table_span">任务名称：</span>
                        <el-select clearable filterable v-model='searchForm.taskName' class="y_table_cellLogy" style="min-width:100px ;max-width: 200px" size='small' placeholder='任务名称' >
                            <el-option v-for="item in taskNameList" :key="item.name" :value="item.name" :label="item.name"></el-option>
                        </el-select>
                    </div>
                </el-col>
                <el-col :span="5">
                    <div @keydown.enter="btnSearch()" class="y_table">
                        <span class="title y_table_span">执行人：</span>
                        <el-select clearable filterable v-model='searchForm.executeUserId' class="y_table_cellLogy" style="min-width:100px ;max-width: 200px" size='small' placeholder='执行人' >
                            <el-option v-for="user in userOption" :key="user.id" :label="user.name" :value="user.id"> </el-option>
                        </el-select>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div style="text-align:right">
                        <el-button size="mini" icon="el-icon-search" type="primary" @click="btnSearch()">查询</el-button>
                        <el-button size="mini" icon="el-icon-refresh" @click='clearSearch'>重置</el-button>
                    </div>
                </el-col>
            </el-row>
        </el-card>
        <el-card class="table-card">
            <div class="table_common_operbar" style="margin-bottom:20px">
                <el-row>
                    <el-col style="flex:1">
                        <el-button icon="el-icon-plus" type="primary" size="small" v-if="permission.btn_other_task_name" @click="taskNameBtn">任务名称配置</el-button>
                        <el-button icon="el-icon-plus" type="primary" size="small" v-if="permission.btn_other_task_create" @click="taskRegistrationBtn">任务登记</el-button>
                    </el-col>
                </el-row>
            </div>
            <el-table :data="tableData" stripe width=80% class="table_data y_Public_table">
                <el-table-column prop="taskName" label="任务名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="executeUserName" label="执行人" show-overflow-tooltip></el-table-column>
                <el-table-column prop="salary" label="工资" show-overflow-tooltip></el-table-column>
                <el-table-column prop="executeDate" label="任务执行日期" show-overflow-tooltip></el-table-column>
                <el-table-column prop="createUserName"  label="登记人" show-overflow-tooltip></el-table-column>
                <el-table-column prop="createDate" label="登记日期" show-overflow-tooltip></el-table-column>
                <el-table-column label="操作" fixed="right" width="150">
                    <template slot-scope="scope">
                        <el-button @click="viewRecord(scope.row)" type="text" size="small">查看</el-button>
                        <el-button @click="showEditDialog(scope.row)" type="text" size="small" v-if="permission.btn_other_task_update">编辑</el-button>
                        <el-button class="btn-del" type="text" size="small" @click="deleteTechnology(scope.row)" v-if="permission.btn_other_task_delete">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="page">
                <div class="total_page"><span> 共{{tableTotalPage}}条 10条/页</span></div>
                <div style="margin-top:3px;text-align:right; margin-bottom:20px;" v-if="tableData.length > 0">
                    <el-pagination background layout="prev, pager, next" :total="tableTotalPage" @current-change="pageChange" :current-page="tableCurrentPage"></el-pagination>
                </div>
            </div>
        </el-card>
        <el-dialog title="任务名称配置" :visible.sync="taskNameVisible" width="30%" center :close-on-click-modal="false" :before-close="taskNameClose">
            <el-table :data="taskNameList" class="table_data y_Public_table">
                <el-table-column label="任务名称" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-input v-if="scope.row.edit" maxlength="20" v-model="scope.row.name"></el-input>
                        <span v-else>{{ scope.row.name }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="150">
                    <template slot-scope="scope">
                        <el-button @click="editTaskName(scope.row)" type="text" size="small">编辑</el-button>
                        <el-button @click="deleteTaskName(scope.$index)" type="text" size="small">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="addTaskName">新增</el-button>
                <el-button type="primary" @click="taskNameSave">确 定</el-button>
                <el-button @click="taskNameClose">取 消</el-button>
            </span>
        </el-dialog>
        <el-dialog title="任务登记" :visible.sync="addDialogVisible" width="35%" center :close-on-click-modal="false" :before-close="addClose">
            <el-form :model="addForm" :rules="rules" ref="addForm" label-width="100px">
                <el-row class="form-row" :gutter="20">
                    <el-col :span="12">
                        <el-form-item prop="taskName" label="任务名称">
                            <el-select clearable v-model='addForm.taskName' size='small' placeholder='任务名称' :style="W?{maxWidth:'200px'}:{maxWidth:'160px'}">
                                <el-option v-for="item in taskNameList" :key="item.name" :value="item.name" :label="item.name"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item prop="executeUserId" label="执行人">
                            <el-select clearable v-model='addForm.executeUserId' size='small' placeholder='执行人' :style="W?{maxWidth:'200px'}:{maxWidth:'160px'}">
                                <el-option v-for="user in userOption" :key="user.id" :label="user.name" :value="user.id"> </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item prop="salary" label="工资">
                            <el-input clearable v-model="addForm.salary" size='small' maxlength="5" placeholder='工资' :style="W?{maxWidth:'200px'}:{maxWidth:'160px'}"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item prop="executeDate" label="执行日期">
                            <el-date-picker v-model="addForm.executeDate" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" :style="W?{maxWidth:'200px'}:{maxWidth:'160px'}"></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="addSave">确 定</el-button>
                <el-button @click="addClose">取 消</el-button>
            </span>
        </el-dialog>
        <el-dialog title="任务登记" :visible.sync="editDialogVisible" width="35%" center :close-on-click-modal="false" :before-close="editClose">
            <el-form :model="editForm" :rules="rules" ref="editForm" label-width="100px">
                <el-row class="form-row" :gutter="20">
                    <el-col :span="12">
                        <el-form-item prop="taskName" label="任务名称">
                            <el-select clearable v-model='editForm.taskName' size='small' placeholder='任务名称' :style="W?{maxWidth:'200px'}:{maxWidth:'160px'}">
                                <el-option v-for="item in taskNameList" :key="item.name" :value="item.name" :label="item.name"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item prop="executeUserId" label="执行人">
                            <el-select clearable v-model='editForm.executeUserId' size='small' placeholder='执行人' :style="W?{maxWidth:'200px'}:{maxWidth:'160px'}">
                                <el-option v-for="user in userOption" :key="user.id" :label="user.name" :value="user.id"> </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item prop="salary" label="工资">
                            <el-input clearable v-model="editForm.salary" size='small' maxlength="5" placeholder='工资' :style="W?{maxWidth:'200px'}:{maxWidth:'160px'}"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item prop="executeDate" label="执行日期">
                            <el-date-picker v-model="editForm.executeDate" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" :style="W?{maxWidth:'200px'}:{maxWidth:'160px'}"></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="editSave">确 定</el-button>
                <el-button @click="editClose">取 消</el-button>
            </span>
        </el-dialog>
        <el-dialog title="任务登记" :visible.sync="viewDialogVisible" width="35%" center :close-on-click-modal="false" :before-close="viewClose">
            <el-row class="form-row" :gutter="20" style="margin-bottom:10px;">
                <el-col :span="12">
                    <div class="y_technology_flex">
                        <span class="y_flex_Cart is-my-required">任务名称：</span>
                        <span>{{ viewForm.taskName }}</span>
                    </div>
                </el-col>
                <el-col :span="12">
                    <div class="y_technology_flex">
                        <span class="y_flex_Cart is-my-required">执行人：</span>
                        <span>{{ viewForm.executeUserName }}</span>
                    </div>
                </el-col>
            </el-row>
            <el-row class="form-row" :gutter="20" style="margin-bottom:10px;">
                <el-col :span="12">
                    <div class="y_technology_flex">
                        <span class="y_flex_Cart is-my-required">工资：</span>
                        <span>{{ viewForm.salary }}</span>
                    </div>
                </el-col>
                <el-col :span="12">
                    <div class="y_technology_flex">
                        <span class="y_flex_Cart is-my-required">执行日期：</span>
                        <span>{{ viewForm.executeDate }}</span>
                    </div>
                </el-col>
            </el-row>
            <el-row class="form-row" :gutter="20" style="margin-bottom:10px;">
                <el-col :span="12">
                    <div class="y_technology_flex">
                        <span class="y_flex_Cart is-my-required">登记人：</span>
                        <span>{{ viewForm.createUserName }}</span>
                    </div>
                </el-col>
                <el-col :span="12">
                    <div class="y_technology_flex">
                        <span class="y_flex_Cart is-my-required">登记日期：</span>
                        <span>{{ viewForm.createDate }}</span>
                    </div>
                </el-col>
            </el-row>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="viewClose">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name:'OtherRecord',
    data(){
        return{
            searchForm:{
                taskName:'',
                executeUserId:''
            },
            userOption:[],
            taskList:[],
            tableData:[],
            addDialogVisible:false,
            taskNameVisible:false,
            taskNameList:[],
            addForm:{
                taskName:'',
                executeUserId:'',
                salary:'',
                executeDate:''
            },
            W:false,
            rules:{
                taskName: [
                    { required: true, message: '请选择任务名称', trigger: ['blur','change'] }
                ],
                executeUserId: [
                    { required: true, message: '请选择执行人', trigger: ['blur','change'] }
                ],
                salary: [
                    {
                        required: true,
                        validator(rule, value, callback) {
                            if(value){
                                let num = Number(value)
                                if(isNaN(num)){
                                    callback(new Error('工资必须为数字'))
                                }else{
                                   callback() 
                                }
                            }else{
                                callback(new Error('请输入工资'))
                            }
                        }
                    }
                ],
                executeDate: [
                    { required: true, message: '请选择执行日期', trigger: ['blur','change'] }
                ],
            },
            editDialogVisible:false,
            editForm:{
                id:'',
                taskName:'',
                executeUserId:'',
                salary:'',
                executeDate:''
            },
            viewDialogVisible:false,
            viewForm:{
                id:'',
                taskName:'',
                executeUserName:'',
                salary:'',
                executeDate:'',
                createUserName:'',
                createDate:''
            },
            tableCurrentPage: 1,
            tableTotalPage: 0,
            fristLoad: false,
            permission: JSON.parse(localStorage.getItem("permission")),
        }
    },
    mounted(){
        let w = document.documentElement.clientWidth || document.body.clientWidth;
        w >= 1900 ? this.W = true : this.W = false
        window.onresize = () => {
            let w = document.documentElement.clientWidth || document.body.clientWidth;
            w >= 1900 ? this.W = true : this.W = false
        }
        this.getUserOption();
        this.getTaskNameList();
        this.search();
    },
    methods:{
        addTaskName(){
            let obj = {
                taskName:'',
                edit:true,
            }
            this.taskNameList.push(obj);
        },
        editTaskName(row){
            row.edit = true;
        },
        deleteTaskName(index){
            this.taskNameList.splice(index,1);
        },
        taskNameBtn(){
            this.taskNameVisible = true;
            this.getTaskNameList();
        },
        getTaskNameList(){
            this.$RequestUtil.get({
                url: "/api/other-task-name/list",
                type: "sync",
                params: {},
                success: res => {
                if (res.code === 0) {
                    this.taskNameList = res.data.map((item)=>{
                        item.edit = false;
                        return item
                    });
                } else {
                    this.$message.error(res.message);
                }
                }
            });
        },
        taskRegistrationBtn(){
            this.addDialogVisible = true;
        },
        btnSearch(){
            this.tableCurrentPage = 1;
            this.search();
        },
        clearSearch(){
            this.searchForm.taskName = '';
            this.searchForm.executeUserId = '';
        },
        pageChange: function (targetPage) {
            this.tableCurrentPage = targetPage;
            this.search();
        },
        search(){
            this.$RequestUtil.loading()
            this.$RequestUtil.post({
                url: '/api/other-task-history/page',
                type:'sync',
                params: {
                    pageNum: this.tableCurrentPage,
                    pageSize: 10,
                    taskName: this.searchForm.taskName,
                    executeUserId: this.searchForm.executeUserId,
                },
                success: (res) => {
                    this.$RequestUtil.loading().close()
                    if (res.msg == "success") {
                        this.tableData = res.data.list;
                        this.tableTotalPage = res.data.total;
                        if (res.data.total == 0 && this.fristLoad) {
                            this.$message.warning('查询不到符合条件的数据');
                        }
                        this.fristLoad = true
                    } else {
                        this.$message.error(res.message || res.msg)
                    }

                }
            });
        },
        getUserOption() {
            this.$RequestUtil.get({
                url: "/api/pull/list/user",
                type: "sync",
                params: {},
                success: res => {
                if (res.code === 0) {
                    this.userOption = res.data;
                } else {
                    this.$message.error(res.message);
                }
                }
            });
        },
        viewRecord(row){
            this.viewDialogVisible = true;
            this.viewForm.id = row.id;
            this.viewForm.taskName = row.taskName,
            this.viewForm.executeDate = row.executeDate;
            this.viewForm.executeUserName = row.executeUserName;
            this.viewForm.salary = row.salary;
            this.viewForm.createUserName = row.createUserName;
            this.viewForm.createDate = row.createDate;
        },
        viewClose(){
            this.viewDialogVisible = false
        },
        showEditDialog(row){
            this.editDialogVisible = true;
            this.editForm.id = row.id;
            this.editForm.taskName = row.taskName,
            this.editForm.executeDate = row.executeDate;
            this.editForm.executeUserId = row.executeUserId;
            this.editForm.salary = row.salary;
        },
        deleteTechnology(row){
            this.$confirm('删除后，数据无法恢复, 是否继续?', '提示', {
                cancelButtonClass: "btn-custom-cancel",
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$RequestUtil.get({
                    url: '/api/other-task-history/delete',
                    type: 'sync',
                    params: {
                        id: row.id
                    },
                    success: (res) => {
                        if (res.code == 0) {
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.search();
                        } else if (res.code == -1) {
                            this.$message({
                                type: 'error',
                                message: '删除失败!'
                            });
                        }
                    },

                });
            });
        },
        taskNameSave(){
            let msg = false;
            if(this.taskNameList.length==0){
                msg = true;
            }else{
                this.taskNameList.forEach((val)=>{
                    if(val.name==null || val.name==undefined || val.name=='' || val.name.indexOf(" ")>-1){
                        msg = true;
                    }
                })
            }
            if(msg){
                this.$message.warning('任务名称不能为空!');
                return
            }
            let params = this.taskNameList.map((val)=>{
                return {name:val.name}
            })
            this.$RequestUtil.post({
                url: '/api/other-task-name/ack',
                type:'sync',
                params: params,
                success: (res) => {
                    if (res.msg == "success") {
                        this.taskNameVisible = false;
                        this.getTaskNameList();
                        this.$message.success('保存成功');
                    } else {
                        this.$message.error(res.message || res.msg)
                    }
                }
            });
        },
        taskNameClose(){
            this.taskNameVisible = false;
        },
        addSave(){
            this.$refs['addForm'].validate((valid) => {
                if (valid) {
                    this.$RequestUtil.post({
                        url: '/api/other-task-history/create',
                        params: {
                            id: this.addForm.id,
                            taskName: this.addForm.taskName,
                            executeDate: this.addForm.executeDate,
                            executeUserId: this.addForm.executeUserId,
                            salary: Number(this.addForm.salary)
                        },
                        success: (res) => {
                            if (res.code == 0) {
                                this.$message({
                                    type: 'success',
                                    message: '新增成功'
                                })
                                this.addClose();
                                this.search();
                            } else {
                                this.$message({
                                    type: 'error',
                                    message: res.message
                                });
                            }
                        }
                    });
                }
            })
        },
        addClose(){
            this.$refs['addForm'].resetFields()
            this.addDialogVisible = false;
        },
        editSave(){
            this.$refs['editForm'].validate((valid) => {
                if (valid) {
                    this.$RequestUtil.post({
                        url: '/api/other-task-history/update',
                        params: {
                            id: this.editForm.id,
                            taskName: this.editForm.taskName,
                            executeDate: this.editForm.executeDate,
                            executeUserId: this.editForm.executeUserId,
                            salary: Number(this.editForm.salary)
                        },
                        success: (res) => {
                            if (res.code == 0) {
                                this.$message({
                                    type: 'success',
                                    message: '编辑成功'
                                })
                                this.editClose();
                                this.search();
                            } else {
                                this.$message({
                                    type: 'error',
                                    message: res.message
                                });
                            }
                        }
                    });
                }
            })
        },
        editClose(){
            this.$refs['editForm'].resetFields()
            this.editDialogVisible = false;
        },
    }
}
</script>
<style scoped>
.page {
    display: flex;
    justify-content: flex-end;
}

.total_page {
    margin-top: 8px;
    margin-right: 26px;
    color: #606266;
    font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/views/Rework/OtherRecord.vue